import "src/decidim/elections/waiting_room.js";
import "src/decidim/elections/live_results_update.js";
import "src/decidim/elections/question_status_checker.js";
require.context("../images", true);
import "entrypoints/decidim_elections.scss";
